<script>
import RequestAccess from "@/components/RequestAccess.vue";

export default {
  name: "NoAccountView",
  components: {
    RequestAccess
  }
};
</script>

<template>
  <main class="p-0 py-sm-5 d-flex flex-column align-items-center">
    <RequestAccess
      :headline="$t('noAccount.headline')"
      :description="$t('noAccount.description')"
    />
  </main>
</template>
